import { Injectable } from "@angular/core";
import { v4 as uuidv4 } from "uuid";
import { environment } from "../../../environments/environment";
import { CommonReferentiel } from "../../types/common-referentiel";
import { ListsByClass$Params } from "../generated/erp-api/fn/dictionary-api/lists-by-class";
import { Dictionary } from "../generated/erp-api/models/dictionary";
import { Hub } from "../generated/erp-api/models/hub";
import { DictionaryApiService } from "../generated/erp-api/services/dictionary-api.service";
import { HubApiService } from "../generated/erp-api/services/hub-api.service";

@Injectable({
  providedIn: "root",
})
export class AppReferentialResolverService {
  commonReferential: CommonReferentiel = {
    dictionaries: [],
    hubs: [],
  };

  static readonly DEFAULT_LANG = environment.defaultLang; // move to environment

  constructor(
    private dictionaryApiService: DictionaryApiService,
    private hubApiService: HubApiService,
  ) {}

  public loadDictionaries(moduleName: string, classes: string[]): void {
    const lang = this.getCurrentLang();
    const keyCache = moduleName + "_" + lang;
    if (sessionStorage.getItem(keyCache)) {
      this.commonReferential.dictionaries = JSON.parse(
        sessionStorage.getItem(keyCache) || "",
      );
      return;
    }
    const params: ListsByClass$Params = {
      "x-api-canal": "web",
      "x-api-requestId": uuidv4(),
      lang: this.getCurrentLang(),
      body: classes,
    };
    this.dictionaryApiService.listsByClass(params).subscribe((response) => {
      if (response.body) {
        this.commonReferential.dictionaries = response.body;
        sessionStorage.setItem(
          keyCache,
          JSON.stringify(this.commonReferential.dictionaries),
        );
      } else {
        console.error("Error loading dictionaries");
      }
    });
  }

  public loadHubs(): void {
    if (sessionStorage.getItem("hubs")) {
      this.commonReferential.dictionaries = JSON.parse(
        sessionStorage.getItem("hubs") || "",
      );
      return;
    }
    const params = {
      "x-api-canal": "web",
      "x-api-requestId": uuidv4(),
      lang: this.getCurrentLang(),
    };
    this.hubApiService.listHubs(params).subscribe((response) => {
      if (response.body) {
        this.commonReferential.hubs = response.body;
        sessionStorage.setItem(
          "hubs",
          JSON.stringify(this.commonReferential.hubs),
        );
      }
    });
  }

  public retrieveHub(key: number): Hub | undefined {
    return this.commonReferential.hubs?.find((h) => h.id === key);
  }

  public hubs(): Array<Hub> {
    return this.commonReferential.hubs || [];
  }

  public retrieveLabel(keyClass: string, key: string): string {
    const dictionaryClass = this.commonReferential.dictionaries?.find(
      (d) => d.className === keyClass,
    );
    return (
      dictionaryClass?.dictionary?.find((d) => d.code === key)?.name || key
    );
  }

  public retrieveDictionaries(keyClass: string): Array<Dictionary> {
    const dictionaryClass = this.commonReferential.dictionaries?.find(
      (d) => d.className === keyClass,
    );
    return dictionaryClass?.dictionary || [];
  }

  private getCurrentLang(): string {
    return (
      sessionStorage.getItem("lang") ||
      AppReferentialResolverService.DEFAULT_LANG
    );
  }
}
